import React, { useState } from "react";
import {
  AccordionContent,
  AccordionItem,
} from "../../components-shadcn/accordion";

import CustomAccordionTrigger from "../../../src/components/CustomAccordionTrigger";
import { Checkbox } from "../../../src/components-shadcn/checkbox";
import axios from "axios";
import { useStore } from "../../lib/store";
import { toast } from "sonner";
import ContractModal from "./ContractModal";
import { AmplitudeLog } from "../../lib/amplitude";

interface Props {
  openItem: string;
}
const SigningContract: React.FC<Props> = ({ openItem }) => {

  const { id_pedido } = useStore();
  const { id_negocio } = useStore();
  const { produtos } = useStore();
  const { set_sync_checkout } = useStore();
  const [agree_terms, set_agree_terms] = useState(false);
  const [loading, set_loading] = useState(false);
  const [open_contract, set_open_contract] = useState(false);

  const update_accept_order_hub = async () => {
    AmplitudeLog("Checkout_Etapa_Concluida",
      {
        nome_etapa: "assinatura_contrato",
        abriu_algum_contrato: open_contract,
        acao: !agree_terms
      }
    );
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/update_accept_order_hub",
        {
          "id_negocio": id_negocio,
          "id_pedido": id_pedido,
          "aceite": !agree_terms
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_loading(false);
        set_sync_checkout(true);
      } else {
        toast(resposta.data.status_code + ": " + resposta.data.msg, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
        set_loading(false);
        set_sync_checkout(true);
        return false;
      }
    } catch (erro: any) {
      toast("Erro ao cadastrar empresa: Exception Error", {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      set_loading(false);
      return false;
    }
  };


  return (
    <AccordionItem value="4">
      <CustomAccordionTrigger value="4" openItem={openItem} number={4} title="Assinaturas do contratos" />
      <AccordionContent>
        <p>Leia os termos dos nossos contratos para continuar.</p>
        <div className="flex flex-row items-center mt-[1.3rem]">
          <Checkbox
            id=""
            checked={agree_terms}
            className={`${agree_terms ? 'border-green-dark bg-green-dark text-white-primary' : 'border-blue-primary border-[2px]'}`}
            onClick={() => { set_agree_terms(agree_terms ? false : true); update_accept_order_hub(); }}
          />
          <p className="font-[500] ml-[0.5rem]">
            Li e concordo com os termos e condições do {' '}
            <ContractModal onClick={() => set_open_contract(true)} link="https://checkout.kinology.com.br/contratar/pdf/contrato_aquisicao.pdf">Contrato de aquisição</ContractModal>
          </p>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default SigningContract;
